/* Visualizzazione coordiante in base al movimento del mouse */
import { useLeaflet } from "react-leaflet";
import L from "leaflet";
import { useEffect } from "react";
import { mouseCoordinate } from './L.Control.MousePosition.js'
const CoordinateController = () => {
    const { map } = useLeaflet();
    useEffect(() => {
    mouseCoordinate()
    L.control.mousePosition().addTo(map);    
      
    },[]);
    return null;
};

export default CoordinateController;